module.exports = __webpack_public_path__ + "img/blue_wave.5046dc15.svg";